// use for web to redirect to the join space or join group page after sign-in
import { useEffect } from 'react';
import { useIsSignedInWeb } from 'features/web/hooks/useIsSignedInWeb';
import { navigate, navigationRef } from 'utils/navigationv6';
const storage = () => window.sessionStorage;
/**
 * Opens the join space or join group page for an invite that PrivateRoute kept
 * before sign-in. navigate() does nothing until the navigator is ready, so the
 * invite is kept, and opened once it is, rather than removed unseen.
 */
const openKeptInvite = () => {
    const joinSpaceToken = storage().getItem('joinSpaceToken');
    if (joinSpaceToken) {
        const joinSpaceName = storage().getItem('joinSpaceName');
        navigate('JoinSpace', {
            accessCode: joinSpaceToken,
            spaceName: joinSpaceName || undefined,
        });
        storage().removeItem('joinSpaceToken');
        storage().removeItem('joinSpaceName');
        return;
    }
    const joinGroupCode = storage().getItem('joinGroupCode');
    if (joinGroupCode) {
        navigate('GroupJoin', { accessCode: joinGroupCode });
        storage().removeItem('joinGroupCode');
    }
};
export const useJoinSpaceRedirect = () => {
    const { isSignedIn } = useIsSignedInWeb();
    useEffect(() => {
        if (!isSignedIn ||
            typeof window === 'undefined' ||
            !('sessionStorage' in window)) {
            return undefined;
        }
        const tryOpen = () => {
            try {
                openKeptInvite();
            }
            catch {
                // noop
            }
        };
        if (navigationRef.isReady()) {
            tryOpen();
            return undefined;
        }
        // The navigator reports its first state once it is ready
        const unsubscribe = navigationRef.addListener('state', () => {
            if (navigationRef.isReady()) {
                unsubscribe();
                tryOpen();
            }
        });
        return unsubscribe;
    }, [isSignedIn]);
};
